import { render, staticRenderFns } from "./order-modal-add.vue?vue&type=template&id=f4d9a2e4&scoped=true"
import script from "./order-modal-add.vue?vue&type=script&lang=js"
export * from "./order-modal-add.vue?vue&type=script&lang=js"
import style0 from "./order-modal-add.vue?vue&type=style&index=0&id=f4d9a2e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9a2e4",
  null
  
)

export default component.exports